export default class CloseButton {
    constructor() {
        this.init = this.init.bind(this);
        this.init();
    }

    init() {
        document.querySelectorAll('.js-close-button').forEach(button => {
            button.addEventListener('click', () => {
                const toClose = button.closest('.js-to-close');
                if (!toClose) return;
                toClose.classList.add('hidden');
            });
        });
    }
}
new CloseButton();
